<!-- @format -->

<template>
	<disabled-text v-if="disabled && pcProps.showDisabledText" :value="value" />
	<el-input v-else v-model="value" :disabled="disabled" type="textarea" clearable show-word-limit></el-input>
</template>

<script setup lang="ts">
	import { type WidgetConfigType } from '../../types';
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
		disabled?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
